/* =============================================================================
   BKS — CADEAU OFFERT V2 — module UNIQUE de logique panier
   -----------------------------------------------------------------------------
   DEPLOYER SOUS : assets/bks-gift-v2.js
   REMPLACE       : assets/bks-gift-sync.js  (+ toute la logique d'ajout/retrait
                    de cadeau qui vivait dans snippets/bks-shipping-bar.liquid).
   BRANCHER       : theme.liquid, a la place de la balise <script bks-gift-sync.js>,
                    APRES le rendu de {% render 'bks-gift-config' %}. Voir README.

   CE QU'IL FAIT (et lui SEUL — fin de la course inter-modules de la V1) :
     • Ajoute UNE seule ligne cadeau, celle du PALIER LE PLUS HAUT atteint :
         - sous-total qualifiant >= 300 EUR  -> Mousse de guidon ASSORTIE (couleur
           auto d'apres la selle, fallback Noir). L'Alcantara est alors RETIRE.
         - 200 EUR <= sous-total < 300 EUR   -> Nettoyant simili-cuir & Alcantara.
         - < 200 EUR                          -> aucun cadeau.
       PAS d'empilement : jamais Mousse + Alcantara en meme temps.
     • Le cadeau est un VRAI produit (prix reel). Il est mis a 0 EUR par un
       discount automatique NATIF Buy X Get Y, evalue par Shopify AU CHECKOUT sur
       le total APRES code. Ce module NE juge JAMAIS le seuil face a un code promo
       (les codes n'existent qu'au checkout, /cart.js ne les voit pas) : c'est le
       BxGy natif qui ferme la fuite. Ici on ne gere que l'UX pre-checkout.
     • Auto-retrait sur mutation du panier (baisse de quantite, retrait d'article,
       options FUSION...) : si le sous-total repasse sous le seuil, le cadeau saute.
     • Clamp qty a 1. Respecte le refus volontaire du client (opt-out). Couleur de
       mousse re-synchronisee si la couleur de selle change.
     • GARDE-FOU ANTI-FACTURATION (filet de securite) : si une ligne cadeau
       ATTENDUE gratuite reste a un prix > 0 (BxGy inactif / fenetre fermee cote
       Shopify / mauvaise config), on la RETIRE et on bloque son re-ajout pour la
       session -> le client n'est JAMAIS facture d'un cadeau. C'est pour ca que la
       fenetre de rarete se pilote a DEUX endroits synchronises (le BxGy natif ET
       les flags active_* de bks-gift-config).

   NE CASSE RIEN :
     • Cible UNIQUEMENT les lignes portant la propriete `_bks_gift` (la mousse a en
       plus `_bks_gift_mousse`). Ne touche jamais aux lignes selle (_bks_id) :
       bks-cart-guard reste seul maitre de celles-la.
     • Re-emballe window.fetch / XHR en CHAINANT le fetch precedent (cart-guard,
       kitdeco, pre-paiement, klaviyo l'emballent aussi) et REAPPLIQUE l'emballage
       apres load + timeouts (comme bks-klaviyo-tracking), pour rester actif meme
       si un script tiers reassigne window.fetch plus tard.
     • 100 % defensif : tout est en try/catch, on n'empeche JAMAIS un ajout client.

   Idempotent : garde `window.__bksGiftV2`. Anti-boucle : verrou BUSY + debounce +
   signature d'etat + une seule mutation par passe (on re-lit le panier ensuite).
   ============================================================================= */
(function () {
  "use strict";
  try { if (window.__bksGiftV2) return; window.__bksGiftV2 = 1; } catch (e) { return; }

  /* 08/10/2026 — configurateurs v2 : interrupteur du redessin de /cart après le cadeau (construire/G-interrupteurs.js) */
  var BKS_REDESSIN = true; /* @@INTERRUPTEUR BKS_REDESSIN@@ */

  /* ----------------------------- CONFIG ----------------------------------- */
  var CFG = {};
  try { CFG = window.__BKS_GIFT_CFG || {}; } catch (e) { CFG = {}; }

  var TH = (CFG.thresholds) || {};
  var T_ALC = int(TH.alcantara, 20000);       // 200,00 EUR en centimes
  var T_MOUSSE = int(TH.mousse, 30000);       // 300,00 EUR

  var PROP_GIFT = (CFG.props && CFG.props.gift) || "_bks_gift";
  var PROP_MOUSSE = (CFG.props && CFG.props.mousse) || "_bks_gift_mousse";

  var ALC = (CFG.alcantara) || {};
  var ALC_VARIANT = int(ALC.variantId, 52567372398933);

  var MOUSSE = (CFG.mousse) || {};
  var MOUSSE_BYCOLOR = (MOUSSE.byColor) || {};
  var MOUSSE_FALLBACK = MOUSSE.fallbackColor || "Noir";

  if (!CFG || !CFG.v) {
    try { console.warn("[BKS gift-v2] __BKS_GIFT_CFG absent — fallback IDs en dur (mousse indisponible sans la carte couleurs)."); } catch (e) {}
  }

  /* ----------------------------- OUTILS ----------------------------------- */
  function int(v, d) { var n = parseInt(v, 10); return isNaN(n) ? d : n; }
  function ss(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } }
  function ssSet(k, v) { try { sessionStorage.setItem(k, v); } catch (e) {} }
  function ssDel(k) { try { sessionStorage.removeItem(k); } catch (e) {} }
  function norm(s) {
    try { return String(s || "").toLowerCase().normalize("NFD").replace(/[̀-ͯ]/g, "").replace(/\s+/g, " ").trim(); }
    catch (e) { return String(s || "").toLowerCase().replace(/\s+/g, " ").trim(); }
  }

  var routeRoot = "/";
  try { if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) routeRoot = window.Shopify.routes.root; } catch (e) {}
  var CART_URL = routeRoot + "cart.js";
  var ADD_URL = routeRoot + "cart/add.js";
  var CHANGE_URL = routeRoot + "cart/change.js";

  /* fenetre de rarete : actif = flag maitre ET (pas de borne OU dans la fenetre). */
  function withinWindow(win) {
    try {
      if (!win) return true;
      var now = Date.now();
      if (win.start) { var s = Date.parse(win.start); if (!isNaN(s) && now < s) return false; }
      if (win.end)   { var e = Date.parse(win.end);   if (!isNaN(e) && now > e) return false; }
      return true;
    } catch (e) { return true; }
  }
  function alcActive()   { return (ALC.active !== false) && withinWindow(ALC.win); }
  function mousseActive() { return (MOUSSE.active !== false) && withinWindow(MOUSSE.win) && int(MOUSSE.productId, 0) > 0; }

  /* --------------------------- LECTURE PANIER ----------------------------- */
  function isGift(it) { try { return !!(it.properties && it.properties[PROP_GIFT]); } catch (e) { return false; } }
  function isMousseGift(it) { try { return !!(it.properties && it.properties[PROP_GIFT] && it.properties[PROP_MOUSSE]); } catch (e) { return false; } }
  function linePrice(it) {
    return (typeof it.final_line_price === "number") ? it.final_line_price
         : (typeof it.line_price === "number") ? it.line_price
         : (it.price || 0) * (it.quantity || 1);
  }
  /* Sous-total qualifiant = tout le panier SAUF les lignes cadeau (un cadeau ne
     finance pas un cadeau). Inclut deja les remises AUTOMATIQUES (-10% complements),
     exclut les codes (normal : ils n'existent qu'au checkout). */
  function qualifying(cart) {
    var items = (cart && cart.items) || [], sum = 0;
    for (var i = 0; i < items.length; i++) { if (!isGift(items[i])) sum += linePrice(items[i]); }
    return sum;
  }
  function findAlc(cart) {
    var items = (cart && cart.items) || [];
    for (var i = 0; i < items.length; i++) {
      var it = items[i];
      if (isGift(it) && !isMousseGift(it) && (it.variant_id === ALC_VARIANT || it.id === ALC_VARIANT)) return it;
    }
    return null;
  }
  function findMousse(cart) {
    var items = (cart && cart.items) || [];
    for (var i = 0; i < items.length; i++) { if (isMousseGift(items[i])) return items[i]; }
    return null;
  }

  /* ---------------- COULEUR DE SELLE -> VARIANTE MOUSSE -------------------- */
  function detectSeatColor(cart) {
    var items = (cart && cart.items) || [], i, p;
    for (i = 0; i < items.length; i++) {
      p = items[i].properties || {}; if (p[PROP_GIFT]) continue;
      if (p._bks_role === "base") { if (p["Dessus"]) return String(p["Dessus"]); if (p["Couleur"]) return String(p["Couleur"]); }
    }
    for (i = 0; i < items.length; i++) { p = items[i].properties || {}; if (!p[PROP_GIFT] && p["Dessus"]) return String(p["Dessus"]); }
    for (i = 0; i < items.length; i++) { p = items[i].properties || {}; if (!p[PROP_GIFT] && p["Couleur"]) return String(p["Couleur"]); }
    return null;
  }
  function mousseVariantForColor(colorName) {
    var key = norm(colorName), k;
    if (key) { for (k in MOUSSE_BYCOLOR) { if (norm(k) === key) return MOUSSE_BYCOLOR[k]; } }
    return null;
  }
  /* Retourne { id, color, matched }. Fallback = Noir, sinon 'couleur au choix',
     sinon 1re variante dispo. id null => on n'ajoutera PAS de mousse (pas de fuite). */
  function chosenMousse(cart) {
    var color = detectSeatColor(cart);
    var id = mousseVariantForColor(color);
    if (id) return { id: id, color: color, matched: true };
    var fb = mousseVariantForColor(MOUSSE_FALLBACK)
          || mousseVariantForColor("couleur au choix");
    if (!fb) { for (var k in MOUSSE_BYCOLOR) { fb = MOUSSE_BYCOLOR[k]; break; } }
    return { id: fb || null, color: null, matched: false };
  }

  /* ------------------------- ETAT & GARDE-FOUS ---------------------------- */
  var BUSY = false, TMR = null, LASTSIG = "";
  var LAST_ADD_AT = 0;                 // pour la temporisation du garde-fou "facture"
  var GRACE_MS = 1500;
  var prev = { init: false, alc: false, mousse: false };
  var selfRemoved = { alc: false, mousse: false };  // retraits que NOUS venons de faire

  function optout(kind) { return ss("bks_gift_optout_" + kind) === "1"; }
  /* 09/10/2026 — tour 1 des vérificateurs (défaut R2 du testeur remises-cadeaux) : un CODE de commande écarte le BxGy,
     le cadeau devient payant et le garde-fou le retire. Avant, le blocage valait pour toute la session : code retiré,
     le cadeau ne revenait plus. Désormais un blocage dû à un code est noté « code:<codes> » et tombe dès que les codes
     applicables du panier changent (code retiré -> le cadeau revient, toujours à 0 € sinon le garde-fou le re-retire).
     Un blocage SANS code (« 1 » : BxGy coupé ou mal réglé) reste pour la session, comme avant. */
  function codeSig(c) {
    try {
      return ((c && c.discount_codes) || []).filter(function (d) { return d && d.applicable; })
        .map(function (d) { return String(d.code || "").toUpperCase(); }).sort().join(",");
    } catch (e) { return ""; }
  }
  function blocked(kind, c) {
    var v = ss("bks_gift_blocked_" + kind);
    if (v === "1") return true;
    if (v && v.indexOf("code:") === 0) {
      if (v.slice(5) === codeSig(c)) return true;
      ssDel("bks_gift_blocked_" + kind);
    }
    return false;
  }
  function bloquer(kind, c) { var s = codeSig(c); ssSet("bks_gift_blocked_" + kind, s ? "code:" + s : "1"); }

  /* 09/10/2026 — tour 1 (défaut R3) : sur la PAGE /cart, Prestige recharge la page après toute modification de ligne ;
     l'état en mémoire (prev) disparaît avant la passe qui aurait noté le refus, et le cadeau revenait. Le refus est donc
     noté AU MOMENT de la requête du client (enveloppe fetch + clic sur un lien /cart/change), par la clé de la ligne
     cadeau lue au dernier passage. Nos propres retraits sont reconnus par leur clé (mémorisée 15 s), quel que soit
     l'ordre des enveloppes fetch des autres scripts. */
  var GIFT_KEYS = { alc: null, mousse: null };
  var OWN_KEYS = {};
  function ownMark(k) { try { if (k) OWN_KEYS[String(k)] = Date.now(); } catch (e) {} }
  function isOwn(k) { var t = OWN_KEYS[String(k)]; return !!(t && Date.now() - t < 15000); }
  function noterRefus(cles) {
    try {
      for (var i = 0; i < cles.length; i++) {
        var k = String(cles[i]);
        if (isOwn(k)) continue;
        if (GIFT_KEYS.alc && k === GIFT_KEYS.alc) ssSet("bks_gift_optout_alc", "1");
        else if (GIFT_KEYS.mousse && k === GIFT_KEYS.mousse) ssSet("bks_gift_optout_mousse", "1");
      }
    } catch (e) {}
  }
  function refusDansRequete(url, init) {
    try {
      if (!/\/cart\/(change|update)(\.js)?(\?|$)/i.test(url || "")) return;
      var b = init && init.body;
      if (typeof b !== "string" || !b) return;
      var j = null; try { j = JSON.parse(b); } catch (e) { return; }
      if (!j || typeof j !== "object") return;
      var cles = [];
      if (/\/cart\/change/i.test(url)) { if (j.id != null && String(j.quantity) === "0") cles.push(String(j.id)); }
      else if (j.updates && typeof j.updates === "object" && !Array.isArray(j.updates)) {
        for (var k in j.updates) { if (Object.prototype.hasOwnProperty.call(j.updates, k) && String(j.updates[k]) === "0") cles.push(k); }
      }
      if (cles.length) noterRefus(cles);
    } catch (e) {}
  }
  try {
    document.addEventListener("click", function (e) {
      try {
        var a = e.target && e.target.closest && e.target.closest('a[href*="/cart/change"]');
        if (!a) return;
        var u = new URL(a.getAttribute("href"), location.href);
        if (u.searchParams.get("quantity") === "0" && u.searchParams.get("id")) noterRefus([u.searchParams.get("id")]);
      } catch (x) {}
    }, true);
  } catch (e) {}

  function cart() {
    return fetch(CART_URL, { cache: "no-cache", headers: { "Accept": "application/json" } }).then(function (r) { return r.json(); });
  }
  function addGift(variantId, extraProps) {
    BUSY = true; LAST_ADD_AT = Date.now();
    var props = { }; props[PROP_GIFT] = "1";
    if (extraProps) { for (var k in extraProps) props[k] = extraProps[k]; }
    return fetch(ADD_URL, {
      method: "POST", headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1, properties: props }] })
    }).then(function (r) { return r.json().then(function (b) { return { ok: r.ok, body: b }; }); })
      .then(function (res) { BUSY = false; if (!res.ok) { warn("ajout cadeau refuse", variantId, res.body && res.body.description); return; } afterMutation(); })
      .catch(function (e) { BUSY = false; warn("add error", e); });
  }
  function changeGift(line, qty) {
    BUSY = true;
    if (qty === 0 && line && line.key) ownMark(line.key);
    return fetch(CHANGE_URL, {
      method: "POST", headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ id: line.key || line.variant_id, quantity: qty })  // TOUJOURS par line key
    }).then(function (r) { return r.json(); })
      .then(function () { BUSY = false; afterMutation(); })
      .catch(function (e) { BUSY = false; warn("change error", e); });
  }
  function warn() { try { console.warn.apply(console, ["[BKS gift-v2]"].concat([].slice.call(arguments))); } catch (e) {} }

  function afterMutation() {
    try { document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true })); } catch (e) {}
    LASTSIG = "";
    setTimeout(function () { refresh(); }, 250);
    if (BKS_REDESSIN) redessinerPagePanier();
  }

  /* 08/10/2026 — configurateurs v2 (BKS_REDESSIN) : sur la PAGE /cart, Prestige ne redessine rien après l'ajout ou le retrait
     du cadeau (le tiroir, lui, se redessine sur « cart:refresh ») : le client voyait l'état d'avant (cadeau absent, total faux).
     On relit la section du panier (Section Rendering API) et on remplace SEULEMENT le corps du tableau et le récapitulatif :
     l'encart kit déco (posé après la barre, hors du formulaire) et la barre cadeau restent en place.
     09/10/2026 — tour 1 des vérificateurs : la requête portait « Accept: application/json » ; avec cet en-tête, Shopify
     répond le PANIER JSON (token, items…) et non les sections : j[sid] était vide, rien n'était jamais redessiné (mesuré :
     357,94 € affichés pour 359,72 € réels pendant 36 s). Sans l'en-tête, la réponse est { "<sid>": "<html>" }. */
  function redessinerPagePanier() {
    try {
      var tv = window.themeVariables && window.themeVariables.settings;
      var surPanier = (tv && tv.pageType === "cart") || /\/cart\/?$/.test(location.pathname);
      if (!surPanier) return;
      var sec = document.querySelector(".shopify-section--main-cart");
      if (!sec || !sec.id) return;
      var sid = sec.id.replace(/^shopify-section-/, "");
      fetch(routeRoot + "cart?sections=" + encodeURIComponent(sid), { cache: "no-cache" })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (j) {
          if (!j || !j[sid]) return;
          var doc = new DOMParser().parseFromString(j[sid], "text/html");
          [".order-summary__body", ".cart-recap"].forEach(function (sel) {
            var ancien = sec.querySelector(sel), neuf = doc.querySelector(sel);
            if (ancien && neuf) ancien.innerHTML = neuf.innerHTML;
          });
          try { document.dispatchEvent(new CustomEvent("bks:cfg2-redessin")); } catch (e) {}
        }).catch(function () {});
    } catch (e) {}
  }

  /* ------------------------- RECONCILIATION ------------------------------- */
  /* UNE seule mutation par passe : on agit, on re-lit (afterMutation), on reconverge. */
  function reconcile(c) {
    if (BUSY) return;
    var qual = qualifying(c);
    var alcLine = findAlc(c);
    var mousseLine = findMousse(c);
    GIFT_KEYS = { alc: alcLine && alcLine.key ? String(alcLine.key) : null, mousse: mousseLine && mousseLine.key ? String(mousseLine.key) : null };

    // Etat desire : UN seul cadeau, palier le plus haut.
    var wantMousse = qual >= T_MOUSSE && mousseActive();
    var wantAlc = !wantMousse && qual >= T_ALC && alcActive();

    // Purge des refus/blocages quand on repasse sous le seuil (le cadeau pourra revenir plus tard).
    if (qual < T_ALC) { ssDel("bks_gift_optout_alc"); ssDel("bks_gift_blocked_alc"); }
    if (qual < T_MOUSSE) { ssDel("bks_gift_optout_mousse"); ssDel("bks_gift_blocked_mousse"); }

    // 0) OPT-OUT : cadeau retire A LA MAIN par le client alors qu'il etait merite.
    //    On ignore les retraits que NOUS avons faits (swap / couleur / facture).
    if (prev.init) {
      if (wantAlc && prev.alc && !alcLine && !selfRemoved.alc) ssSet("bks_gift_optout_alc", "1");
      if (wantMousse && prev.mousse && !mousseLine && !selfRemoved.mousse) ssSet("bks_gift_optout_mousse", "1");
    }
    selfRemoved.alc = false; selfRemoved.mousse = false;
    prev = { init: true, alc: !!alcLine, mousse: !!mousseLine };

    // 1) GARDE-FOU ANTI-FACTURATION : un cadeau ATTENDU gratuit reste paye (>0) ->
    //    le BxGy ne s'applique pas (fenetre fermee cote Shopify / mauvaise config).
    //    On le retire pour ne JAMAIS facturer un cadeau, et on bloque le re-ajout.
    //    Temporisation : on laisse le temps a la remise auto de se refleter apres notre ajout.
    if (Date.now() - LAST_ADD_AT > GRACE_MS) {
      if (wantMousse && mousseLine && linePrice(mousseLine) > 0) {
        warn("mousse ATTENDUE gratuite mais facturee -> retrait + blocage (verifier le BxGy 300 / sa fenetre)");
        bloquer("mousse", c); selfRemoved.mousse = true; return changeGift(mousseLine, 0);
      }
      if (wantAlc && alcLine && linePrice(alcLine) > 0) {
        warn("Alcantara ATTENDU gratuit mais facture -> retrait + blocage (code de commande, ou BxGy 200 / sa fenetre)");
        bloquer("alc", c); selfRemoved.alc = true; return changeGift(alcLine, 0);
      }
    }

    // 2) CLAMP a 1
    if (mousseLine && mousseLine.quantity > 1) return changeGift(mousseLine, 1);
    if (alcLine && alcLine.quantity > 1) return changeGift(alcLine, 1);

    // 3) SWAP DE PALIER (jamais deux cadeaux a la fois)
    if (wantMousse && alcLine) { selfRemoved.alc = true; return changeGift(alcLine, 0); }
    if (wantAlc && mousseLine) { selfRemoved.mousse = true; return changeGift(mousseLine, 0); }

    // 4) SWAP DE COULEUR : la mousse presente ne correspond plus a la selle
    if (wantMousse && mousseLine) {
      var pick = chosenMousse(c);
      if (pick && pick.id && mousseLine.variant_id !== pick.id && mousseLine.id !== pick.id) {
        selfRemoved.mousse = true;         // swap couleur, PAS un opt-out
        return changeGift(mousseLine, 0);
      }
    }

    // 5) AJOUT du cadeau merite et absent (respecte opt-out + blocage)
    if (wantMousse && !mousseLine && !optout("mousse") && !blocked("mousse", c)) {
      var pk = chosenMousse(c);
      if (pk && pk.id) {
        var props = {}; props[PROP_MOUSSE] = "1";
        if (pk.matched && pk.color) props["Assortie à ta selle"] = pk.color;              // "Assortie à ta selle"
        else props["Couleur"] = MOUSSE_FALLBACK + " " + ((CFG.i18n && CFG.i18n.mousseFallbackNote) || "(modifiable)");
        return addGift(pk.id, props);
      }
    }
    if (wantAlc && !alcLine && !optout("alc") && !blocked("alc", c)) {
      return addGift(ALC_VARIANT, null);
    }

    // 6) RETRAIT du cadeau non merite (repasse sous le seuil / palier inactif)
    if (!wantMousse && mousseLine) { selfRemoved.mousse = true; return changeGift(mousseLine, 0); }
    if (!wantAlc && alcLine) { selfRemoved.alc = true; return changeGift(alcLine, 0); }

    // Etat stable -> rien a faire (la boucle se termine ici).
  }

  /* ------------------------- ORCHESTRATION -------------------------------- */
  function handle(c) {
    // 1) repeindre la barre (lecture seule), si presente
    try { if (window.__bksGiftBar && window.__bksGiftBar.refresh) window.__bksGiftBar.refresh(c); } catch (e) {}
    // 2) reconcilier (une passe)
    try {
      if (BUSY) return;
      var qual = qualifying(c);
      var items = (c && c.items) || [];
      var pickId = "";
      try { if (qual >= T_MOUSSE) { var pk = chosenMousse(c); pickId = pk && pk.id ? pk.id : ""; } } catch (e) {}
      var sig = qual + "|m" + pickId + "|c" + codeSig(c) + "|" + items.map(function (i) {
        return (i.variant_id || i.id) + ":" + i.quantity + ":" + ((i.properties || {})[PROP_GIFT] ? "g" : "");
      }).join(",");
      if (sig === LASTSIG) return;   // rien n'a bouge -> pas de reconciliation
      LASTSIG = sig;
      reconcile(c);
    } catch (e) { warn("reconcile error", e); }
    try { document.dispatchEvent(new CustomEvent("bks:gift-v2")); } catch (e) {}
  }

  function refresh(cartObj) {
    try {
      if (cartObj && typeof cartObj.total_price === "number" && Array.isArray(cartObj.items)) { handle(cartObj); return; }
      cart().then(function (c) { handle(c || { items: [], total_price: 0 }); }).catch(function () {});
    } catch (e) { warn("refresh error", e); }
  }

  function schedule() { if (TMR) clearTimeout(TMR); TMR = setTimeout(function () { refresh(); }, 300); }

  /* ------- Detection de TOUTE mutation du panier (fetch + XHR + events) ---- */
  var RX = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/i;

  /* Emballage fetch RESILIENT : reappplique apres load + timeouts pour survivre a
     une reassignation tardive de window.fetch par un script tiers (theme, klaviyo...).
     Flag __bksGiftV2 sur l'enveloppe => idempotent (jamais de double emballage). */
  function patchFetch() {
    try {
      if (!window.fetch || window.fetch.__bksGiftV2) return;
      var prevFetch = window.fetch;
      var wrapped = function (input, init) {
        var url = "";
        try { url = (typeof input === "string") ? input : (input && input.url) || ""; } catch (e) {}
        refusDansRequete(url, init);   /* 09/10/2026 (R3) : refus du cadeau noté AVANT le rechargement de Prestige */
        var p = prevFetch.apply(this, arguments);
        try { if (RX.test(url) && p && p.then) { p.then(function () { schedule(); }).catch(function () {}); } } catch (e) {}
        return p;
      };
      wrapped.__bksGiftV2 = true;
      window.fetch = wrapped;
    } catch (e) {}
  }
  patchFetch();
  document.addEventListener("DOMContentLoaded", patchFetch);
  window.addEventListener("load", patchFetch);
  setTimeout(patchFetch, 1200);
  setTimeout(patchFetch, 3500);
  setTimeout(patchFetch, 8000);

  try {
    var _open = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (m, u) {
      try { if (RX.test(u || "")) this.addEventListener("load", schedule); } catch (e) {}
      return _open.apply(this, arguments);
    };
  } catch (e) {}

  try {
    document.addEventListener("submit", function (e) {
      try { var a = (e.target && e.target.getAttribute("action")) || ""; if (RX.test(a)) schedule(); } catch (_) {}
    }, true);
  } catch (e) {}

  ["cart:updated", "cart:refresh", "cart:change", "variant:add", "cart-drawer:refreshed"].forEach(function (ev) {
    try { document.addEventListener(ev, schedule); } catch (e) {}
  });
  try { window.addEventListener("pageshow", schedule); } catch (e) {}
  try { document.addEventListener("visibilitychange", function () { if (!document.hidden) schedule(); }); } catch (e) {}

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", function () { refresh(); });
  else refresh();

  // Hooks de test/manuels
  try { window.__bksGiftV2Run = function () { LASTSIG = ""; return refresh(); }; } catch (e) {}
})();
